// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-unit[data-v-9e7fd290]{height:calc(100% - 60px)}", ""]);
// Exports
module.exports = exports;
